import { Address } from "./renter.type";

export enum PARTNER_STATUS {
  ACTIVE = "active",
  INACTIVE = "inactive",
  DEFAULTER = "defaulter"
}

export type IPartner = {
  _id?: string;
  cnpj: string;
  companyName: string;
  fantasyName: string;
  owner: ComnplementType;
  email: string;
  operationalContact: ComnplementType;
  walletId: string;
  status: string;
  updatedAt: Date;
  createdAt: Date;
  address: Address;
  companyType: string;
  incomeValue?: number;
  partnersType?: string;
  managementTrafficfines: {
    enabled: boolean;
    date: Date | string;
  };
  digitalCertificateExpirationDate?: Date | string | null;
}

type ComnplementType = {
  name: string;
  phone: string;
};

export type PartnerType = {
  _id: string;
  name: string;
  status: PARTNER_STATUS;
  updatedAt: string;
  createdAt: string;
};

export const emptyPartners = () => ({
  _id: "",
  cnpj: "",
  companyName: "",
  fantasyName: "",
  owner: {
    name: "",
    phone: "",
  },
  operationalContact: {
    name: "",
    phone: "",
  },
  walletId: "",
  email: "",
  status: PARTNER_STATUS.ACTIVE,
  updatedAt: new Date(),
  createdAt: new Date(),
  address: {
    zipcode: "",
    street: "",
    number: 0,
    complement: "",
    city: "",
    state: "",
    district: "",
    latitude: 0,
    longitude: 0,
  },
  companyType: "",
  incomeValue: 0,
  partnersType: "",
  managementTrafficfines: {
    enabled: false,
    date: new Date(),
  },
}) as IPartner;
